/**
 * Help-center events. One module, so if the destination for article feedback
 * changes -- the visual handover leaves it open ("ke mana data tombol Belum
 * terjawab dikirim") -- this is the only file that changes.
 *
 * For now it goes to the storefront's GA4 property through the gtag snippet in
 * public/index.html, as `help_feedback` with the article id, so the "belum
 * terjawab" answers can be read per article next to the rest of kyou.id's data.
 * Without gtag (blocked, or not loaded yet) the call is a no-op.
 */
export function trackHelpFeedback(articleId, helpful) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.gtag("event", "help_feedback", {
    article_id: articleId,
    helpful: helpful ? "yes" : "no"
  });
}

/**
 * A search on /help/search and how many articles it found. GA4's own
 * site-search tracking already records the query (it reads `?keyword=`); this
 * adds the result count, so searches that found nothing can be listed.
 */
export function trackHelpSearch(keyword, resultCount, categorySlug) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.gtag("event", "help_search", {
    search_term: keyword,
    results_count: resultCount,
    category: categorySlug || "all"
  });
}
